export const Sources = {
  TPREK: 'tprek',
  LINKED: 'linked',
} as const;

// Add ID that matches the sports ontology tree branch that has the Culture,
// sports and leisure department (KuVa) as its parent.
// https://www.hel.fi/palvelukarttaws/rest/v4/ontologytree/551
export const SPORTS_DEPARTMENT_ONTOLOGY_TREE_ID = 551 as const;
